/*========================================================================
* 회원 정보 관리 (회원 정보, 권한 및 점수)
========================================================================*/
// Action type ( 액션 타입 )
const SET_INFO_ACC = 'authorityAcc/SET_INFO_ACC';
const SET_INFO_CUST = 'authorityCust/SET_INFO_CUST';

// Action Creator Function ( 액션 생성 함수 )
export const setInfoAcc = auth => ({ type: SET_INFO_ACC, auth });
export const setInfoCust = info => ({ type: SET_INFO_CUST, info });

// 회원 정보
const accInfoInitial = {
  company: {},
  email: '',
  ip: [],
  is_allow_ip: '',
  is_allow_access_time: '',
  name: '',
  phone_number: '',
  roles: [], // 회원 권한 String []
  roles_num: '', // 회원 권한 Number 
  uid: '',
  access_score: '', // 권한 관리 점수 [100: Readonly, 200: Add, 300: Modify/Delete]
  master: '',
}
// 고객 정보 
const custInfoInitial = {
  corp: '',
  id: '',
  name: '',
  uuid: '',
  changePass: ''
} 

// Reducer function ( 리듀서 함수 )
export function authorityAcc(state = accInfoInitial, action) {
  switch (action.type) {
    case SET_INFO_ACC:
      return {
        company: action.auth.dPcompany,
        email: action.auth.dPemail,
        ip: action.auth.dPip,
        is_allow_ip: action.auth.dPis_allow_ip,
        is_allow_access_time: action.auth.dPis_allow_access_time,
        name: action.auth.dPname,
        phone_number: action.auth.dPphone_number,
        roles: action.auth.dProles,
        roles_num: action.auth.dProles_num,
        uid: action.auth.dPuid,
        access_score: action.auth.dPaccess_score,
        master: action.auth.dPmaster,
      }
    default:
      return state;
  }
}

export function authorityCust(state = custInfoInitial, action) {
  switch (action.type) {
    case SET_INFO_CUST:
      return {
        corp: action.info.dPcorp,
        id: action.info.dPid,
        name: action.info.dPname,
        uuid: action.info.dPuuid,
        changePass: action.info.dPchangePass,
      }
    default:
      return state;
  }
}



/*========================================================================
* 로그인 상태 유지 관리
========================================================================*/
// 회원 로그인 상태
const SET_LOGGED_ACC = 'loggedAcc/SET_LOGGED_ACC';

export const setLoggedAcc = loggeds => ({ type: SET_LOGGED_ACC, loggeds });

const accLoggedInitial = JSON.parse(sessionStorage.getItem("accSessionData"))?.isLogin || false


export function loggedAcc(state = accLoggedInitial, action) {
  switch (action.type) {
    case SET_LOGGED_ACC:
      return action.loggeds;
      default:
        return state;
  }
}
    
// 고객 로그인 상태
const SET_LOGGED_CUST = 'loggedCust/SET_LOGGED_CUST';

export const setLoggedCust = loggeds => ({ type: SET_LOGGED_CUST, loggeds });

const custLoggedInitial = JSON.parse(sessionStorage.getItem("custSessionData"))?.isLogin || false

export function loggedCust(state = custLoggedInitial, action) {
  switch (action.type) {
    case SET_LOGGED_CUST:
      return action.loggeds;
    default:
      return state;
  }
}


/*========================================================================
* Local / PROD 경로 설정
========================================================================*/
// const hostName = window.location.hostname;
// const urlState = hostName === 'localhost' || hostName === '127.0.0.1' ?
//   'https://frontdev.paygate.net/' /* Local URL */
//   :
//   '/' /* PROD URL */

// export function curUrl(state = urlState) { return state; }